import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLoginPage from './pages/admin/login';
import AdminForgotPasswordPage from './pages/admin/forgot-password';
import AdminRegisterPage from './pages/admin/register';
import AdminResetPasswordPage from './pages/admin/reset-password';
import AdminUsersPage from './pages/admin/users';
import AdminEditorialIntelligencePage from './pages/admin/editorial-intelligence';
import AdminEditorialIntelligenceDetailPage from './pages/admin/editorial-intelligence/detail';
import AdminWriteArticlePage from './pages/admin/editorial-intelligence/write-article';
import AdminDashboardPage from './pages/admin/dashboards';
import AdminConfigEditorialIntelligencePage from './pages/admin/config/editorial-intelligence';
import AdminArticlesPage from './pages/admin/articles';
import AdminArticlesWritePage from './pages/admin/articles/write';
import AdminArticleWritePage from './pages/admin/articles/article-write';
import SupportPage from './pages/support/SupportPage';
import AdminUserManualPage from './pages/admin/user-manual';
import AdminLayout from './layouts/admin';
import ProtectedRoute from './components/admin/ProtectedRoute';

import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CssBaseline />
    <BrowserRouter>
      <Routes>
        {/* Rotas fora de /admin → redirecionar para /admin/dashboards */}
        <Route path="/" element={<Navigate to="/admin/dashboards" replace />} />
        <Route path="/chat/:chatId" element={<Navigate to="/admin/dashboards" replace />} />

        {/* Admin - public */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/forgot-password" element={<AdminForgotPasswordPage />} />
        <Route path="/admin/register/:invite_token" element={<AdminRegisterPage />} />
        <Route path="/register/:invite_token" element={<AdminRegisterPage />} />
        <Route path="/admin/reset-password/:reset_password_token" element={<AdminResetPasswordPage />} />

        {/* Admin - protected */}

        {/* Redirect legado */}
        <Route path="/admin/users" element={<Navigate to="/admin/config/users" replace />} />

        <Route
          path="/admin/config/users"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminUsersPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/config/editorial-intelligence"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminConfigEditorialIntelligencePage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/editorial-intelligence"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminEditorialIntelligencePage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/dashboards"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminDashboardPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/editorial-intelligence/:editorial_intelligence_id/write-article"
          element={
            <ProtectedRoute>
              <AdminLayout fullWidth>
                <AdminWriteArticlePage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/editorial-intelligence/:editorial_intelligence_id"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminEditorialIntelligenceDetailPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/articles"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminArticlesPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/articles/write"
          element={
            <ProtectedRoute>
              <AdminLayout fullWidth>
                <AdminArticlesWritePage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/articles/:article_id/write"
          element={
            <ProtectedRoute>
              <AdminLayout fullWidth>
                <AdminArticleWritePage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/support"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <SupportPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/user-manual"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminUserManualPage />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/admin/dashboards" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
